// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger, SplitText } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("turbo:load", () => {
  // Initialize Lenis
  const lenis = new Lenis();

  // Use requestAnimationFrame to continuously update the scroll
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  //lenis.on("scroll", ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);

  gsap.to("#header", {
    scrollTrigger: {
      trigger: "#header",
      start: "bottom top",
      toggleActions: "play none none reset",
    },
    maxWidth: "100%",
    borderRadius: 0,
  });

  gsap.to(document.getElementById("header").parentElement, {
    scrollTrigger: {
      trigger: "#header",
      start: "bottom top",
      toggleActions: "play none none reset",
    },
    padding: 0,
  });

  gsap.fromTo(
    "#animate .container",
    {
      height: 0,
      duration: 1,
    },
    {
      scrollTrigger: {
        trigger: "#animate",
        start: "top center",
        scrub: true,
      },
      height: "100%",
    },
  );

  const servicesIntroSplit = new SplitText(
    document.getElementById("servicesIntro"),
    { type: "chars" },
  );

  gsap.from(servicesIntroSplit.chars, {
    scrollTrigger: {
      trigger: "#servicesIntro",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },
    opacity: 0.2,
    stagger: 0.1,
    ease: "power1.inOut",
  });

  const services = gsap.utils.toArray(
    document.querySelector("#services").children,
  );

  gsap.from(services, {
    scrollTrigger: {
      trigger: "#services",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },

    opacity: 0.2,
    yPercent: 50,
    transformOrigin: "top",
    stagger: 0.1,
    ease: "power1.inOut",
  });

  const aboutHeadlineTween = gsap.timeline({
    scrollTrigger: {
      trigger: "#about h2",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },
  });

  const aboutHeadlineSplit = new SplitText("#about h2", {
    type: "chars",
  });

  aboutHeadlineTween.from("#about h2", {
    scale: 1.3,
  });

  aboutHeadlineTween.from(aboutHeadlineSplit.chars, {
    opacity: 0.2,
    stagger: 0.1,
    ease: "power1.inOut",
  });

  const aboutSubheadingSplit = new SplitText("#about p", { type: "chars" });
  gsap.from(aboutSubheadingSplit.chars, {
    scrollTrigger: {
      trigger: "#about p",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },
    opacity: 0.2,
    stagger: 0.1,
    ease: "power1.inOut",
  });

  gsap.from("#about img", {
    scrollTrigger: {
      trigger: "#about",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },
    yPercent: 100,
    transformOrigin: "bottom",
    opacity: 0.2,
    stagger: 0.1,
    ease: "power1.inOut",
  });

  // features tween
  const featuresHeadingSplit = new SplitText("#features .heading h2", {
    type: "chars",
  });
  const featuresHeadingTween = gsap.timeline({
    scrollTrigger: {
      trigger: "#features",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },
  });

  featuresHeadingTween.from(featuresHeadingSplit.chars, {
    opacity: 0.2,
    stagger: 0.1,
    ease: "power1.inOut",
  });

  const featuresSubheadingSplit = new SplitText("#features .heading p", {
    type: "chars",
  });

  featuresHeadingTween.from(featuresSubheadingSplit.chars, {
    opacity: 0.2,
    stagger: 0.1,
    ease: "power1.inOut",
  });

  const features = gsap.utils.toArray(
    document.querySelector("#features .features dl").children,
  );

  gsap.from(features, {
    scrollTrigger: {
      trigger: "#features .features",
      start: "top 80%",
      end: "top 20%",
      scrub: 1,
    },
    opacity: 0.2,
    yPercent: 50,
    transformOrigin: "top",
    stagger: 0.1,
    ease: "power1.inOut",
  });
});
